import React from 'react';

import { getImageUrl } from '@zego/imgixUtils';

import FluidImageBase from './FluidImageBase';

export default function StaticImageImage({ src, ...props }) {
  return <FluidImageBase src={getImageUrl(src)} {...props} />;
}
